import {FunctionComponent}                  from "react";
import React                                from "react";
import {Link}                               from "react-router-dom";
import styled                               from "styled-components";
import EnvelopeIcon                         from "../../assets/icons/envelope-white.svg";
import {defaultPrimaryButtonIconLeftStyles} from "../../styles/DefaultPrimaryButtonIconLeftStyles";
import {ButtonType}                         from "../../types/ButtonType";


const StyledButton = styled.button`
    ${defaultPrimaryButtonIconLeftStyles};
    background-image: url(${EnvelopeIcon});
    background-position: 20px 50%;
`;

const StyledLink = styled(Link)`
    ${defaultPrimaryButtonIconLeftStyles};
    background-image: url(${EnvelopeIcon});
    background-position: 20px 50%;

`;

const StyledHref = styled.a`
    ${defaultPrimaryButtonIconLeftStyles};
    background-image: url(${EnvelopeIcon});
    background-position: 20px 50%;

`;


const ButtonPrimaryContact: FunctionComponent<ButtonType> = (props) => {

  const RenderButton = (props: any) => {
    if (props.to) {
      return <StyledLink to={props.to} {...props}>{props.children}</StyledLink>;
    } else if (props.href) {
      return <StyledHref href={props.href} {...props}>{props.children}</StyledHref>;
    } else {
      return <StyledButton type={props.type} {...props}>{props.children}</StyledButton>;
    }
  };

  return (
    <>
      {
        RenderButton(props)
      }
    </>
  );
};


StyledButton.defaultProps = {
  type: "button",
};

export default ButtonPrimaryContact;
